import { useEffect, useState } from 'react';
import { ApiResponse } from 'src/API/types/types';
import { isError } from 'src/components/PGE/ErrorPlaceHolder';
type Props<K> = {
  apiFunction: Function;
};
const uesApiLogic = <T>({ apiFunction }: Props<T>) => {
  const [data, setData] = useState<T>();
  const [error, setError] = useState<boolean>(false);
  const [lastUpdated, setLastUpdated] = useState<string>();
  const [dataSource, setDataSource] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await apiFunction();
      console.log(response);
      if (!isError<T>(response?.result)) {
        setData(response?.result);
        setLastUpdated(response?.lastUpdated);
        setDataSource(response?.dataSource);
      } else setError(true);
    } catch (error) {
      console.log('error', error);
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const refetch = () => {
    setError(false);
    setData(undefined);
    fetchData();
  };

  return {
    data,
    lastUpdated,
    dataSource,
    error,
    isLoading,
    refetch
  };
};

export default uesApiLogic;
